import Box from "@/common/components/Box"
import Button from "@/common/components/Button"
import { ChangeHistory } from "@/common/components/ChangeHistory"
import { LeadHeader } from "@/features/establishmentLeadsFunnel/components/LeadHeader"
import { ResponsibleSection } from "@/features/establishmentLeadsFunnel/components/ResponsibleSection"
import { useAdvanceEstablishmentLead } from "@/features/establishmentLeadsFunnel/hooks/useAdvanceEstablishmentLead"
import { EstablishmentLeadData } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type"
import { useQueryClient } from "@tanstack/react-query"
import { FormProvider } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { useEstablishmentLeadForm } from "../../hooks/useEstablishmentLeadForm"

export const LeadRegisteredForm = ({
  id,
  establishmentLead
}: {
  id: string,
  establishmentLead: EstablishmentLeadData
}) => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const redirectOnSuccess = (path: string) => {
    queryClient.invalidateQueries({queryKey: ['establishmentLead', id]})
    navigate(path)
  }

  const {
    mutate: advanceEstablishmentLead,
    isPending: advanceEstablishmentLeadIsPending,
    isError: advanceEstablishmentLeadIsError,
  } = useAdvanceEstablishmentLead({
    id,
    onSuccess: () => redirectOnSuccess('/establishment-leads'),
  })

  const formMethods = useEstablishmentLeadForm({ establishmentLead })

  return (
    <FormProvider {...formMethods}>
      <LeadHeader
        establishmentLeadId={id}
        display_name={establishmentLead.display_name}
        url={establishmentLead.general_information.company_logo?.url}
        showArchiveButton
        archived_at={establishmentLead.archived_at}
        buttons={
          <Button
          type="button"
          data-testid="initial_qualifying_button"
          className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
          variant="default"
          onClick={() => advanceEstablishmentLead()}
          disabled={advanceEstablishmentLeadIsPending}
        >
          Iniciar Qualificação
        </Button>
        }
      />
      <div className='flex gap-6'>
        <Box className="w-full flex flex-col gap-6 max-h-[calc(100vh-130px)] overflow-y-auto shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
          {advanceEstablishmentLeadIsError && <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, tente novamente.</p>}
          <ResponsibleSection establishmentLead={establishmentLead} disabled />
        </Box>
        <ChangeHistory
          logs={establishmentLead.logs || []}
          bodyClassName="max-h-[calc(100vh-186px)]"
          entityId={id}
        />
      </div>
    </FormProvider>
  )
}
